import {useEffect, useState} from 'react';

import {getTopBreweries} from 'services/breweries';
import Brewery from 'typescript/models/Brewery';

export const useTopBreweries = (): [Brewery[], boolean] => {
  const [topBreweries, setTopBreweries] = useState<Brewery[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const topBreweriesResponse = await getTopBreweries();

      setTopBreweries(topBreweriesResponse.data.data);
      setIsLoading(false);
    })();
  }, []);

  return [topBreweries, isLoading];
};
